import styled from 'styled-components';
import { Icon } from 'components/atoms';
import { columnsGutter, container } from 'styles/grid';
import { minWidth } from 'styles/media-queries';
import { opacityBlack50 } from '@spotify-internal/encore-web';
import { sectionMargins, spacer12, spacer32 } from 'styles/spacers';
import { black } from 'styles/colors';

// Styled components
export const OverlayBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 20;
  background-color: ${opacityBlack50};
  overflow-y: scroll;
`;

export const MainContainer = styled.div`
  ${container}
  ${columnsGutter}

  position: static;
  margin: 2.4rem auto;
`;

export const ButtonContainer = styled.div`
  ${container}
  padding: ${spacer12};
  position: sticky;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const OverlayContainer = styled.div`
  background-color: ${props => props.theme.backgroundColor};
  color: ${props => props.theme.textColor};
  border-radius: 24px;
  padding-top: ${spacer32};
  padding-bottom: ${spacer32};
`;

export const Navigation = styled.nav`
  ${container}
  display: flex;
  justify-content: ${props => (props.$onlyNext ? 'flex-end' : 'space-between')};
`;

export const NavigationItem = styled.button`
  display: flex;
  align-items: center;
  gap: 0.8rem;

  font-weight: 800;
  font-size: 1.8rem;
  line-height: 2rem;

  border-bottom: 2px solid ${props => props.theme.textColor};
`;

export const Arrow = styled(Icon)`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${black};

  svg {
    width: 2rem;
    height: 2rem;
    path {
      fill: ${props => props.theme.textColor};
    }
  }
`;

export const TitleContainer = styled.div`
  ${container}
  text-align: center;
  margin-top: ${spacer32};
`;

export const Modules = styled.div`
  .gallery-module {
    h2 {
      font-size: 1.6rem;
      font-weight: 700;
      line-height: 140%;
      letter-spacing: 0;
    }
    .gallery-grid {
      ${minWidth.md`
        grid-template-columns: repeat(2, 1fr);
      `}
      ${minWidth.lg`
        grid-template-columns: repeat(3, 1fr);
      `}
    }
  }
  .cta-banner {
    padding-top: 0;
  }
  .image-module {
    figcaption {
      text-align: center;
      margin-top: ${spacer32};
      color: ${props => props.theme.textColor};
    }
  }
`;

export const ModuleContainer = styled.div`
  ${container}
  ${sectionMargins}
`;
